import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
} from "react-router-dom";
import Sidebar from "./components/Sidebar";
import EventTypes from "./pages/EventTypes";
import EventForm from "./pages/EventForm";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LoginPage from "./pages/LoginPage"; // Import LoginPage
import SignupPage from "./pages/SignupPage"; // Import SignupPage
import ForgotPasswordPage from "./pages/ForgotPasswordPage"; // Import ForgotPasswordPage
import ResetPasswordPage from "./pages/ResetPasswordPage"; // Import ResetPasswordPage
import VerifyEmailPage from "./pages/VerifyEmailPage"; // Import VerifyEmailPage
import AvailabilityPage from "./pages/AvailabilityPage";
import BookingPage from "./pages/BookingPage";
import Bookings from "./pages/UserBookings";
import HomePage from "./pages/HomePage";
import MeetingIntegrationPage from "./pages/MeetingIntegrationPage";

// import RegisterCompany from "./pages/RegisterCompany";
import ManageCompanies from "./pages/ManageCompanies";
import ManageServices from "./pages/ManageServices";
import ManageEmployees from "./pages/ManageEmployees";

import CompanyLanding from "./pages/CompanyLanding";
import Checkout from "./pages/Checkout";
import BookingSuccess from "./pages/BookingSuccess";
import ManageBookings from "./pages/ManageBookings";
import ManageCompanyBookings from "./pages/ManageCompanyBookings";
import LocalTaxPage from "./pages/settings/LocalTaxPage";
import DiscountsPage from "./pages/settings/DiscountsPage";
import PackagesPage from "./pages/settings/PackagesPage";
import BusinessHoursPage from "./pages/BusinessHoursPage";
// import EmployeeServiceMapping from "./pages/EmployeeServiceMapping";
import Reports from "./pages/Reports";
// 🧭 Role selection & onboarding pages
import RoleSelectPage from "./pages/RoleSelectPage";
import SelectRole from "./pages/SelectRole";
import SelectCompanyPage from "./pages/SelectCompanyPage";
import SelectBranchPage from "./pages/SelectBranchPage";
import Profile from "./pages/Profile";
import ExplorePage from "./pages/ExplorePage";

import CancellationRefunds from "./pages/CancellationRefunds";
import TermsConditions from "./pages/TermsConditions";
import Shipping from "./pages/Shipping";
import Privacy from "./pages/Privacy";
import ContactUs from "./pages/ContactUs";
import ManageBillingTaxes from "./pages/ManageBillingTaxes.js";
import VerifyMobilePage from "./pages/VerifyMobilePage.js";
//import './App.css';
import AnalyticsTracker from "./components/AnalyticsTracker"; // ← Import
// NEW: Import Inventory Manager
import InventoryManager from "./components/InventoryManager";
import ManageCustomers from "./components/ManageCustomers";
function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  if (loading) return null;
  return (
    <Router>
      <AnalyticsTracker /> {/* ← Add this inside Router */}
      <div className="d-flex flex-column min-vh-100">
        <Navbar user={user} setUser={setUser} />
        {user ? (
          <div className="apjsbx">
            <Sidebar />
            <main className="flexg1">
              <Routes>
                <Route path="/events" element={<EventTypes />} />
                <Route
                  path="/availability"
                  element={<AvailabilityPage userId={user.sub} />}
                />
                <Route
                  path="/event/edit/:id"
                  element={<EventForm isEdit={true} userId={user.sub} />}
                />
                {/* <Route path="/events/:slug" element={<BookingPage />} /> */}
                <Route
                  path="/events/:companySlug/:eventSlug"
                  element={<BookingPage />}
                />
                <Route path="/bookings" element={<Bookings />} />
                <Route path="/meeting-integration" element={<MeetingIntegrationPage />} />
                {/* Add more protected routes here */}
                {/* New Company Admin Pages */}
                <Route path="/companies" element={<ManageCompanies />} />
                <Route path="/services" element={<ManageServices />} />
                <Route path="/employees" element={<ManageEmployees />} />
                {/* <Route
                  path="/employee-services"
                  element={<EmployeeServiceMapping />}
                /> */}
                <Route path="/reports" element={<Reports />} />
                <Route path="/manage-bookings" element={<ManageBookings />} />
                <Route path="/manage-customers" element={<ManageCustomers />} />
                <Route
                  path="/manage-company-bookings"
                  element={<ManageCompanyBookings />}
                />
                <Route path="/settings/local-tax" element={<LocalTaxPage />} />
                <Route path="/settings/discounts" element={<DiscountsPage />} />
                <Route path="/settings/packages" element={<PackagesPage />} />
                <Route
                  path="/settings/business-hours"
                  element={<BusinessHoursPage />}
                />
                <Route path="/select-role" element={<SelectRole />} />
                <Route path="/role-select" element={<RoleSelectPage />} />
                <Route path="/select-company" element={<SelectCompanyPage />} />
                <Route path="/select-branch" element={<SelectBranchPage />} />
                <Route path="/profile" element={<Profile />} />
                <Route
                  path="/company/:companySlug"
                  element={<CompanyLanding />}
                />
                <Route
                  path="/company/:companySlug/checkout"
                  element={<Checkout />}
                />
                <Route
                  path="/booking-success/:bookingId"
                  element={<BookingSuccess />}
                />
                <Route path="/explore" element={<ExplorePage />} />
                <Route
                  path="/manage-billing-taxes"
                  element={<ManageBillingTaxes />}
                />
                <Route
                  path="/verify-mobile/:payload"
                  element={<VerifyMobilePage />}
                />
                {/* NEW: Inventory Route */}
                <Route
                  path="/companies/:companyId/inventory"
                  element={<InventoryManagerWrapper />}
                />
              </Routes>
            </main>
          </div>
        ) : (
          <main className="flex-grow-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage setUser={setUser} />} />
              <Route path="/signup" element={<SignupPage />} />
              {/* <Route path="/companysignup" element={<RegisterCompany />} /> */}
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route
                path="/reset-password/:token"
                element={<ResetPasswordPage />}
              />
              <Route
                path="/verify-email/:token/:type?"
                element={<VerifyEmailPage />}
              />
              <Route
                path="/verify-mobile/:payload"
                element={<VerifyMobilePage />}
              />
              <Route
                path="/events/:companySlug/:eventSlug"
                element={<BookingPage />}
              />
              <Route
                path="/company/:companySlug"
                element={<CompanyLanding />}
              />
              <Route
                path="/company/:companySlug/checkout"
                element={<Checkout />}
              />
              <Route
                path="/booking-success/:bookingId"
                element={<BookingSuccess />}
              />
              <Route path="/explore" element={<ExplorePage />} />
              {/* You can redirect or handle unknown routes too */}
              <Route
                path="/cancellation-refunds"
                element={<CancellationRefunds />}
              />
              <Route
                path="/terms-and-conditions"
                element={<TermsConditions />}
              />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/contact-us" element={<ContactUs />} />
            </Routes>
          </main>
        )}

        <Footer />
      </div>
    </Router>
  );
}
// Wrapper to extract companyId from URL and pass to InventoryManager
const InventoryManagerWrapper = () => {
  const { companyId } = useParams();
  return <InventoryManager companyId={parseInt(companyId)} />;
};
export default App;
